"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_SLUG_TO_ID = exports.PRODUCT_SLUG_TO_BRAND_ID = exports.PRODUCT_ID_TO_SLUG = exports.isCashBackProduct = exports.getBrandIdForProduct = exports.ProductSlug = exports.ProductId = exports.PREMIUM_PRODUCTS = exports.PREMIUM_BRANDS = exports.getProductForBrand = exports.getClassOfServiceForProduct = exports.getDefaultClassOfServiceForBrand = void 0;
const Products_1 = require("@cardlesshq/constants/src/Products");
const shared_1 = require("./shared");
const getProductForBrand = ({ brandId, classOfService, }) => {
    if (!classOfService) {
        classOfService = getDefaultClassOfServiceForBrand(brandId);
    }
    let maybeProductSlug;
    let maybeProductId;
    switch (brandId) {
        case Products_1.BrandId.Avianca:
            return classOfService === shared_1.ClassOfService.PREMIUM
                ? Products_1.ProductId.AviancaLifemilesElite
                : Products_1.ProductId.AviancaLifemiles;
        case Products_1.BrandId.DemoPurple:
            return classOfService === shared_1.ClassOfService.PREMIUM
                ? Products_1.ProductId.DemoPurpleGoldCard
                : Products_1.ProductId.DemoPurpleSilverCard;
        case Products_1.BrandId.Qatar:
            return classOfService === shared_1.ClassOfService.PREMIUM
                ? Products_1.ProductId.QatarPremiumCard
                : Products_1.ProductId.QatarStandardCard;
        case Products_1.BrandId.LATAM:
            return classOfService === shared_1.ClassOfService.PREMIUM
                ? Products_1.ProductId.LATAMWorldEliteCard
                : Products_1.ProductId.LATAMCard;
        case Products_1.BrandId.Cavs:
            return Products_1.ProductId.CavsCard;
        case Products_1.BrandId.Celtics:
            return Products_1.ProductId.CelticsCard;
        case Products_1.BrandId.LiverpoolFc:
            return Products_1.ProductId.LiverpoolFcCard;
        case Products_1.BrandId.ManUtd:
            return Products_1.ProductId.ManUtdCard;
        case Products_1.BrandId.Marlins:
            return Products_1.ProductId.MarlinsCard;
        case Products_1.BrandId.Pelicans:
            return Products_1.ProductId.PelicansCard;
        case Products_1.BrandId.Simon:
            return Products_1.ProductId.SimonCard;
        case Products_1.BrandId.TAPAirPortugal:
            return Products_1.ProductId.TAPAirPortugalCard;
        default:
            maybeProductSlug = swapFn(Products_1.PRODUCT_SLUG_TO_BRAND_ID)[brandId];
            maybeProductId =
                maybeProductSlug && Products_1.PRODUCT_SLUG_TO_ID[maybeProductSlug];
            return maybeProductId ? maybeProductId : undefined;
    }
};
exports.getProductForBrand = getProductForBrand;
const swapFn = (obj) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const res = {}; // not worried about impl safety
    Object.entries(obj).forEach(([key, value]) => {
        res[value] = key;
    });
    return res;
};
const PREMIUM_BRANDS = [
    Products_1.BrandId.Avianca,
    Products_1.BrandId.LATAM,
    Products_1.BrandId.Qatar,
];
exports.PREMIUM_BRANDS = PREMIUM_BRANDS;
const PREMIUM_PRODUCTS = [
    Products_1.ProductId.AviancaLifemilesElite,
    Products_1.ProductId.LATAMWorldEliteCard,
    Products_1.ProductId.QatarPremiumCard,
];
exports.PREMIUM_PRODUCTS = PREMIUM_PRODUCTS;
const getDefaultClassOfServiceForBrand = (brandUuid) => {
    if (brandUuid && PREMIUM_BRANDS.includes(brandUuid)) {
        return shared_1.ClassOfService.PREMIUM;
    }
    else {
        return shared_1.ClassOfService.STANDARD;
    }
};
exports.getDefaultClassOfServiceForBrand = getDefaultClassOfServiceForBrand;
const getClassOfServiceForProduct = (productUuid) => {
    if (productUuid && PREMIUM_PRODUCTS.includes(productUuid)) {
        return shared_1.ClassOfService.PREMIUM;
    }
    else {
        return shared_1.ClassOfService.STANDARD;
    }
};
exports.getClassOfServiceForProduct = getClassOfServiceForProduct;
var Products_2 = require("@cardlesshq/constants/src/Products");
Object.defineProperty(exports, "ProductId", { enumerable: true, get: function () { return Products_2.ProductId; } });
Object.defineProperty(exports, "ProductSlug", { enumerable: true, get: function () { return Products_2.ProductSlug; } });
Object.defineProperty(exports, "getBrandIdForProduct", { enumerable: true, get: function () { return Products_2.getBrandIdForProduct; } });
Object.defineProperty(exports, "isCashBackProduct", { enumerable: true, get: function () { return Products_2.isCashBackProduct; } });
Object.defineProperty(exports, "PRODUCT_ID_TO_SLUG", { enumerable: true, get: function () { return Products_2.PRODUCT_ID_TO_SLUG; } });
Object.defineProperty(exports, "PRODUCT_SLUG_TO_BRAND_ID", { enumerable: true, get: function () { return Products_2.PRODUCT_SLUG_TO_BRAND_ID; } });
Object.defineProperty(exports, "PRODUCT_SLUG_TO_ID", { enumerable: true, get: function () { return Products_2.PRODUCT_SLUG_TO_ID; } });
